<template>
  <div class="service-config">
    <Store ref="storeRef" :storeIds="formData.storeIds" v-bind="$attrs" />
    <SignCompany
      ref="signCompanyRef"
      :enterpriseId="formData.enterpriseId"
      :cooperationPlatform="formData.cooperationPlatform"
      :cooperationPlatformNames="formData.cooperationPlatformNames"
      v-bind="$attrs"
    />
    <StoreConfig
      ref="storeConfigRef"
      :storeServices="formData.storeServices"
      v-bind="$attrs"
    />
    <CarRule ref="carRuleRef" :notesVO="formData.notesVO" v-bind="$attrs" />
    <NomalQuestion
      ref="nomalQuestionRef"
      :asks="formData.asks"
      v-bind="$attrs"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { cloneDeep } from 'lodash'
import Store from './components/Store/index.vue'
import SignCompany from './components/SignCompany/index.vue'
import CarRule from './components/CarRule/index.vue'
import StoreConfig from './components/StoreService/index.vue'
import NomalQuestion from './components/NomalQuestion/index.vue'
import { useFormValidation } from './hooks/useFormValidation'
import { useEditFormState } from './hooks/useEditFormState'

const { validate: validateForm } = useFormValidation()
const { state: formState } = useEditFormState()

const props = defineProps({
  serviceInfoVO: {
    type: Object,
    default: () => ({}),
  },
})

const storeRef = ref(null)
const signCompanyRef = ref(null)
const carRuleRef = ref(null)
const storeConfigRef = ref(null)
const nomalQuestionRef = ref(null)
const formData = ref({})

watch(
  () => props.serviceInfoVO,
  (n, o) => {
    if (n === o || !n) return
    formData.value = cloneDeep(n)
  },
  {
    immediate: true,
  },
)

watch(
  [() => formState.value.modelId, () => formState.value.cityCode],
  ([newModelId, newCityCode], [oldModelId, oldCityCode]) => {
    if (
      (newModelId !== oldModelId && oldModelId !== null) ||
      (newCityCode !== oldCityCode && oldCityCode !== null)
    ) {
      formData.value.storeIds = []
      formData.value.enterpriseId = null
      formData.value.cooperationPlatform = []
    }
  },
  {
    deep: true,
  },
)

const validate = () => {
  const validateTasks = [
    { ref: storeRef, name: 'store' },
    { ref: signCompanyRef, name: 'signCompany' },
    { ref: carRuleRef, name: 'carRule' },
    { ref: storeConfigRef, name: 'storeConfig' },
    { ref: nomalQuestionRef, name: 'nomalQuestion' },
  ]

  return validateForm(validateTasks)
}
const preStoreValidate = () => {
  const validateTasks = [
    { ref: carRuleRef, name: 'carRule' },
    { ref: storeConfigRef, name: 'storeConfig' },
    { ref: nomalQuestionRef, name: 'nomalQuestion' },
  ]

  return validateForm(validateTasks)
}

defineExpose({
  validate,
  preStoreValidate,
  getData: () => {
    return {
      storeIds: storeRef.value.getData(),
      enterpriseId: signCompanyRef.value.getData()?.enterpriseId,
      cooperationPlatform: signCompanyRef.value.getData()?.cooperationPlatform,
      notesVO: carRuleRef.value.getData(),
      storeServices: storeConfigRef.value.getData(),
      asks: nomalQuestionRef.value.getData(),
      state: 1,
    }
  },
})
</script>

<style lang="scss" scoped>
.service-config {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.add-question {
  text-align: center;
  padding: 20px;
}
</style>
